import React from 'react';
import CustomThemeCard from './CustomThemeCard';

interface CustomThemesSectionProps {
  site: Site;
  pages?: Array<Page>;
  enabledTheme?: string;
  customThemeCount?: number;
  customThemeList?: CustomTheme[];
  updateSite: (site: Site) => void;
  updateCurrentPage?: (pageVersion: PageVersion) => void;
  openColorPanel: (e: React.MouseEvent<any>) => void;
  selectCustomTheme: (customThemeButtonId: string) => void;
  decrementCustomThemeCount?: () => void;
  incrementCustomThemeCount?: () => void;
  handleDeleteCustomTheme?: (id: number) => void;
  handleOpenColorPanel?: (e: React.MouseEvent<any>) => void;
}

const CustomThemesSection = (props: CustomThemesSectionProps) => {
  const {
    site,
    pages,
    enabledTheme,
    customThemeList,
    updateSite,
    updateCurrentPage,
    openColorPanel,
    selectCustomTheme,
    decrementCustomThemeCount,
    handleDeleteCustomTheme = () => {},
    handleOpenColorPanel,
  } = props;

  return (
    <>
      {customThemeList &&
        customThemeList.length > 0 &&
        customThemeList.map(theme => (
          <CustomThemeCard
            key={theme.key}
            themeKey={theme.key}
            themeName={theme.name}
            site={site}
            pages={pages}
            enabledTheme={enabledTheme}
            updateSite={updateSite}
            updateCurrentPage={updateCurrentPage}
            openColorPanel={openColorPanel}
            handleOpenColorPanel={handleOpenColorPanel}
            selectCustomTheme={selectCustomTheme}
            decrementCustomThemeCount={decrementCustomThemeCount}
            isDeleteThemeDisabled={customThemeList.length === 1}
            handleDeleteCustomTheme={handleDeleteCustomTheme}
          />
        ))}
    </>
  );
};

export default CustomThemesSection;
